import React from 'react';
import _get from 'lodash/get';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Placeholder from '@lib/assets/icons/img-placeholder.svg?react';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import { SelectPanelOptionRendererProps } from '../types';
import { getOptionLabel } from '../utils';
import styles from '../SelectPanel.module.scss';

export function AssetOption({
  option,
  isSelected,
  isMulti,
}: SelectPanelOptionRendererProps): React.ReactElement {
  const { t } = useTranslation();
  const { data } = option || {};
  const icon =
    _get(data, 'iconAttached.urls.small') ||
    _get(data, 'iconAttached.urls.original') ||
    _get(data, 'iconAttached.fileTag');
  const isPoorWifi = _get(data, 'poorWifi');
  const iconRender = icon ? <img src={icon} alt="" /> : <Placeholder />;

  return (
    <div
      className={classNames(
        styles.entityOption,
        styles.entityOptionWithLeftIcon,
        { active: isSelected, [styles.optionWithCheckbox]: isMulti },
      )}
    >
      {isMulti && (
        <span className={styles.optionCheckbox}>
          <MaterialIcon
            icon={isSelected ? 'check_box' : 'check_box_outline_blank'}
            size="md-18"
          />
        </span>
      )}
      <span className={styles.entityOptionIcon}>{iconRender}</span>
      <span className={styles.entityOptionLabelWrap}>
        <span
          className={classNames(styles.entityOptionLabel, {
            [styles.optionLabelWithOfflineIcon]: isPoorWifi,
          })}
        >
          {getOptionLabel(option, t)}
          {isPoorWifi && (
            <span className={styles.offlineIcon}>
              <MaterialIcon icon="wifi_off" size="md-16" />
            </span>
          )}
        </span>
      </span>
    </div>
  );
}
